import type { ReactNode } from 'react'

export function FullPageMessage({
  title,
  body,
  children,
}: {
  title: string
  body?: string
  children?: ReactNode
}) {
  return (
    <div className="mx-auto flex min-h-[60dvh] max-w-lg flex-col justify-center px-4 text-center">
      <h1 className="font-display text-xl text-ink">{title}</h1>
      {body && <p className="mt-3 text-sm text-inksoft">{body}</p>}
      {children && <div className="mt-5">{children}</div>}
    </div>
  )
}
